<div class="section">



    <!--     *********     BLOGS 1      *********      -->
    <div class="blog-1" id="blog-1">
        <div class="container">
            <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                    <h2 class="title">Latest News</h2>
                    <br />
                    <div *ngFor="let item of Data; index as item_index" class="card card-plain card-blog">



                        <div *ngIf="item_index % 2 == 0" class="row">
                            <div class="col-md-5">
                                <div class="card-image">
                              
                                    <img crossorigin="anonymous" class="img" [src]="item.media" />
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="card-body">
                                    <h6 class="card-category text-info">{{item.category}}</h6>
                                    <h3 class="card-title">
                                        <a [routerLink]="['/info_news_detail', item._id]">{{item.title}}</a>
                                    </h3>
                                    <p class="card-description">
                                        {{item.summary}} <a href="javascript:void(0)"> Read More </a>
                                    </p>
                                    <p class="author">
                                        by <a href="javascript:void(0)"><b>{{item.author}}</b></a> {{item.created}}
                                    </p>
                                </div>

                            </div>
                        </div>





                        <div *ngIf="item_index % 2 == 1" class="row">

                            <div class="col-md-7">
                                <div class="card-body">
                                    <h6 class="card-category text-info">{{item.category}}</h6>
                                    <h3 class="card-title">
                                        <a [routerLink]="['/info_news_detail', item._id]">{{item.title}}</a>
                                    </h3>
                                    <p class="card-description">
                                        {{item.summary}} <a href="javascript:void(0)"> Read More </a>
                                    </p>
                                    <p class="author">
                                        by <a href="javascript:void(0)"><b>{{item.author}}</b></a> {{item.created}}
                                    </p>
                                </div>

                            </div>

                            <div class="col-md-5">
                                <div class="card-image">
                               
                                    <img crossorigin="anonymous" class="img" [src]="item.media" />
                                </div>
                            </div>
                           
                        </div>



                    </div>

                    
                </div>
            </div>
        </div>
    </div>

</div>